import {
  ConflictResolution,
  DesignConflictSection
} from '../types';
import { getChangeItemObject } from './get-change-item-object';
import { mapDesignConflictItems } from './map-design-conflict-items';

function autoResolveItems(
  sections: DesignConflictSection[],
  ids: Set<string>,
  resolution: ConflictResolution
): DesignConflictSection[] {
  return mapDesignConflictItems(sections, (item) => {
    const changeItem = getChangeItemObject(item.source);
    if (
      changeItem == null
      || typeof changeItem !== 'object'
    ) {
      return;
    }

    if (
      (
        // Try to update parent.
        'id' in changeItem
        && ids.has(changeItem.id!)
      ) || (
        // Try to update child.
        'props' in changeItem
        && 'parentComponentID' in changeItem.props
        && ids.has(changeItem.props.parentComponentID!)
      )
    ) {
      item.resolution = resolution;
    }
  });
}

export function setDesignConflictItemResolution(
  sections: DesignConflictSection[],
  key: string,
  resolution: ConflictResolution
) {
  const autoResolveIds = new Set<string>();
  sections = mapDesignConflictItems(sections, (item) => {
    if (item.key === key) {
      item.resolution = resolution;
      const changeItem = getChangeItemObject(item.source);
      if (
        changeItem == null
        || typeof changeItem !== 'object'
      ) {
        return;
      }

      if (
        'id' in changeItem
        && changeItem.id
      ) {
        // Get ID from parent to update children.
        autoResolveIds.add(changeItem.id);
      }

      if (
        'props' in changeItem
        && 'parentComponentID' in changeItem.props
        && changeItem.props.parentComponentID
      ) {
        // Get ID from child to update parent.
        autoResolveIds.add(changeItem.props.parentComponentID);
      }
    }
  });

  return autoResolveItems(
    sections,
    autoResolveIds,
    resolution
  );
}
